export default __webpack_public_path__ + "static/media/des1.446a4f6f.jpeg";